import authApi from '@seeneco-ui/api/modules/platform/modules/auth';
import billingApi from '@seeneco-ui/api/modules/platform/modules/billing';

import { atrFrameworkApi } from './atr-framework';
import { businessHubApi } from './business-hub';
import leadsApi from './leads';
import { preferencesApi } from './preferences';
import securityApi from './security';
import statusApi from './status';

const api = {
	atrFramework: atrFrameworkApi,
	auth: authApi,
	billingPack: billingApi,
	businessHub: businessHubApi,
	leadsPack: leadsApi,
	preferencesApi: preferencesApi,
	securityPack: securityApi,
	statusPack: statusApi,
};

export { api };
